import { ReactNode } from "react";
import { motion } from "framer-motion";

interface PageHeroProps {
  backgroundImage: string;
  title: string;
  subtitle?: string;
  children?: ReactNode;
  fullHeight?: boolean;
}

const PageHero = ({ backgroundImage, title, subtitle, children, fullHeight = false }: PageHeroProps) => {
  return (
    <section className={`relative ${fullHeight ? 'min-h-screen' : 'min-h-[50vh]'} flex items-end pb-16`}>
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className="page-hero-overlay" />
      <div className="relative z-10 container mx-auto px-8 lg:px-16">
        {children || (
          <>
            {subtitle && (
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-xs tracking-[0.3em] uppercase font-body text-[hsl(40,56%,54%)] mb-4"
              >
                {subtitle}
              </motion.p>
            )}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="font-heading text-5xl md:text-7xl font-light text-white"
            >
              {title}
            </motion.h1>
          </>
        )}
      </div>
    </section>
  );
};

export default PageHero;
